export default __webpack_public_path__ + "static/media/ON.ea52f4db.svg";